export default "__VITE_ASSET__61f04c5b__"